/**
 * This value is arbitrary and can be changed because someone with a much more important job title
 * than me decides the sky is green. All of that to say: I'm hardcoding it.
 */
const HIGH_TIER_CONTRIBUTION_THRESHOLD = 10000;

function getAnnonatedContributorName(row) {
  const name = row["Attribution Nameline"];
  const annotation =
    row.flag.toUpperCase() === "BOTH"
      ? "*+"
      : row.flag.toUpperCase() === "NEW"
        ? "*"
        : row.flag.toUpperCase().startsWith("BEQUEST") // this flag is sometimes suffixed by a question mark
          ? "+"
          : "";
  return name + annotation;
}

/**
 * Takes a category name and coverts it to up to 2 separate values: a mininum and maximum
 * number that make up a range. If only one number exists in the name, this is the minimum and
 * the maximum is assumed to be unbounded.
 *
 * @param {*} category
 * @returns {{}} an object containing the min and max value for a category
 */
function translateCategoryNameToNumericRange(category) {
  const numericRepresentationsOfCategories = category
    .split(" ")
    .map((word) => word.replace(/\D/g, ""))
    .filter(Boolean)
    .map((numericString) => Number(numericString))
    .sort((num1, num2) => num1 - num2);

  return {
    min: numericRepresentationsOfCategories[0],
    max: numericRepresentationsOfCategories[1] ?? null
  };
}

export function sortContributorsByCategory(contributors) {
  return contributors.reduce((prev, row) => {
    const next = { ...prev };
    if (!row.Category) {
      return next;
    }
    const item = {
      name: getAnnonatedContributorName(row),
      category: row.Category
    };

    if (prev[row.Category]) {
      next[row.Category] = {
        ...next[row.Category],
        contributors: [...next[row.Category].contributors, item]
      };
    } else {
      next[row.Category] = {
        range: translateCategoryNameToNumericRange(row.Category),
        contributors: [item]
      };
    }
    return next;
  }, {});
}

export function getLowTierContributors(contributorsByCategory) {
  return Object.values(contributorsByCategory)
    .filter(
      (category) => category.range.max && category.range.max < HIGH_TIER_CONTRIBUTION_THRESHOLD
    )
    .map((category) => category.contributors)
    .flatMap((contributors) =>
      contributors.map((contributor) => {
        return { name: `${contributor.name} (${contributor.category})` };
      })
    );
}

export function getHighTierContributors(contributorsByCategory) {
  return Object.keys(contributorsByCategory)
    .filter((key) => contributorsByCategory[key].range.min >= HIGH_TIER_CONTRIBUTION_THRESHOLD)
    .map((category) => {
      return {
        category,
        contributors: contributorsByCategory[category].contributors
      };
    });
}
